import { ISerpaqReturn, ISerpaqShipping } from '../../interfaces/deliveries.interface';

export namespace SerpaqDeliveriesActions {
  export class GetAll {
    static readonly type = '[SerpaqDeliveries] Get All';
  }

  export class SetAll {
    static readonly type = '[SerpaqDeliveries] Set All';
    constructor(
      public shipments: ISerpaqShipping[],
      public returns: ISerpaqReturn[],
    ) {}
  }

  export class UploadExcel {
    static readonly type = '[SerpaqDeliveries] Upload Excel';
    constructor(public file: File) {}
  }

  export class LoadManual {
    static readonly type = '[SerpaqDeliveries] Load Manual';
    constructor(
      public trackings: string[],
      public target: 'envio' | 'devolucion' = 'envio',
    ) {}
  }

  // Action SetType removida: la reclasificación manual entre envíos y devoluciones
  // ya no existe. Si se requiere reactivarla en el futuro, restaurar de git history.

  export class RefreshStatuses {
    static readonly type = '[SerpaqDeliveries] Refresh Statuses';
  }
}
